import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const submitFeedbackSuccess = () => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK_SUCCESS,
  };
};
export const submitFeedbackFailed = (error) => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK_FAILED,
    payload: error,
  };
};
export const submitFeedbackStarted = () => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK_STARTED,
  };
};

export const submitFeedbackReset = () => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK_RESET,
  };
};

export const submitFeedback = (feedbackData: {
  userId: string;
  providerId: string;
  feedback: string;
}) => {
  return (dispatch) => {
    dispatch(submitFeedbackStarted());
    axios
      .post(serverconfigs.submitFeedbackUrl, feedbackData)
      .then((response) => {
        console.log(response);
        dispatch(submitFeedbackSuccess());
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(submitFeedbackFailed(error));
      });
  };
};
